import {NgModule} from "@angular/core";
import {IntDefaultNotificationComponent} from "./int-default-notification.component";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [IntDefaultNotificationComponent],
  exports: [IntDefaultNotificationComponent]
})
export class IntDefaultNotificationModule {}
